// extracted by mini-css-extract-plugin
export default {"container":"OperatorUserPageTabsSkeleton_container__h-lhu","tab":"OperatorUserPageTabsSkeleton_tab__rb+tM","text":"OperatorUserPageTabsSkeleton_text__zEWJV"};